import { c as _c } from "react/compiler-runtime";
import { PredictBlockNumbersResponseApiModel } from "@/app/tools/block-finder/page.client";
import BlockPickerAdvancedItemBlock from "../advanced/BlockPickerAdvancedItemBlock";
export default function BlockPickerResultTableRowModal(t0) {
  const $ = _c(19);
  const {
    predictedBlock
  } = t0;
  const t1 = predictedBlock.count === 1 ? "Block" : "Blocks";
  const t2 = predictedBlock.count === 1 ? "includes" : "include";
  let t3;
  if ($[0] !== predictedBlock.blockNumberIncludes || $[1] !== t1 || $[2] !== t2) {
    t3 = <p className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">{t1} that{" "}{t2}{" "}{predictedBlock.blockNumberIncludes}</p>;
    $[0] = predictedBlock.blockNumberIncludes;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== predictedBlock.count) {
    t4 = <p className="tw-mb-0 tw-text-sm tw-font-normal tw-text-iron-400">Total: {predictedBlock.count}</p>;
    $[4] = predictedBlock.count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== predictedBlock.blockNumberIncludes || $[10] !== predictedBlock.blockNumbers) {
    let t7;
    if ($[12] !== predictedBlock.blockNumberIncludes) {
      t7 = block => <div key={block} className="tw-text-base tw-font-normal"><BlockPickerAdvancedItemBlock key={block} block={block} blockParts={predictedBlock.blockNumberIncludes} /></div>;
      $[12] = predictedBlock.blockNumberIncludes;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t6 = predictedBlock.blockNumbers.map(t7);
    $[9] = predictedBlock.blockNumberIncludes;
    $[10] = predictedBlock.blockNumbers;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="tw-mt-4 tw-space-y-0.5">{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="tw-rounded-lg tw-overflow-hidden"><div className="tw-p-6 tw-max-h-[calc(100vh_+_-100px)] tw-overflow-y-auto">{t5}{t7}</div></div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}